var React = require('react');

function IconContentsAnaly (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M20.805 15.2v8.4H4.351V6.8h5.9a7.694 7.694 0 0 1 .564-2.4H4.351A2.383 2.383 0 0 0 2 6.8v16.8A2.383 2.383 0 0 0 4.351 26h16.454a2.383 2.383 0 0 0 2.351-2.4v-6zm-1.763 6H6.114l3.232-4.236 2.3 2.832 3.232-4.248zm3.291-10.932a5.434 5.434 0 0 0 .823-2.868 5.29 5.29 0 1 0-10.578 0 5.336 5.336 0 0 0 5.277 5.4 5.134 5.134 0 0 0 2.809-.84l3.667 3.74L26 14zm-4.466.132a3 3 0 1 1 2.938-3 2.971 2.971 0 0 1-2.938 3z","transform":"translate(-2 -2)"}));
}

IconContentsAnaly.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconContentsAnaly;

IconContentsAnaly.default = IconContentsAnaly;
